module.exports = __webpack_public_path__ + "static/avatar-2d636b2576e47883ca2b1f68f4fc9587.png";